export default __webpack_public_path__ + "static/media/repeat.b23d0cb0.gif";